var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManagePasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 231,
    viewBox: "0 0 260 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_502_7502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.368 150.287C148.759 150.721 148.052 151.015 147.302 151.122L123.142 154.57C116.285 155.545 110.296 155.421 104.828 154.199C92.8632 151.531 82.3866 144.619 75.3334 134.725L52.1067 102.17C49.4253 98.4129 49.4695 93.2908 52.2021 89.4223L76.6932 54.8609C78.1359 52.7922 80.2808 51.246 82.7139 50.5107L123.051 38.1982C127.562 36.8141 132.398 38.4152 135.071 42.1706L158.315 74.75C165.363 84.6259 168.526 96.8181 167.227 109.081C166.631 114.707 164.83 120.459 161.73 126.667L150.807 148.583C150.471 149.267 149.973 149.847 149.368 150.287Z",
    fill: "url(#paint0_linear_502_7502)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_502_7502)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_502_7502",
    maskUnits: "userSpaceOnUse",
    x: 98.4366,
    y: 42.8925,
    width: 148.161,
    height: 172.273,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 98.4366,
    y: 42.8925,
    width: 148.161,
    height: 172.273
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.3 209.244C167.308 209.183 166.33 208.893 165.462 208.372L137.485 191.585C129.546 186.817 123.42 181.637 118.741 175.754C108.502 162.888 103.315 146.862 104.153 130.621L106.89 77.1644C107.204 70.9948 111.482 65.7031 117.52 63.9828L171.546 48.6791C174.756 47.7435 178.264 47.9437 181.402 49.2305L233.529 70.4371C239.364 72.8013 243.071 78.5451 242.749 84.7063L240.01 138.203C239.181 154.421 232.399 169.773 220.918 181.436C215.65 186.786 209.025 191.251 200.671 195.095L171.205 208.686C170.29 209.113 169.292 209.297 168.3 209.244Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.3 209.244C167.308 209.183 166.33 208.893 165.462 208.372L137.485 191.585C129.546 186.817 123.42 181.637 118.741 175.754C108.502 162.888 103.315 146.862 104.153 130.621L106.89 77.1644C107.204 70.9948 111.482 65.7031 117.52 63.9828L171.546 48.6791C174.756 47.7435 178.264 47.9437 181.402 49.2305L233.529 70.4371C239.364 72.8013 243.071 78.5451 242.749 84.7063L240.01 138.203C239.181 154.421 232.399 169.773 220.918 181.436C215.65 186.786 209.025 191.251 200.671 195.095L171.205 208.686C170.29 209.113 169.292 209.297 168.3 209.244Z",
    fill: "#247CB8",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.243 210.243C168.794 210.276 169.266 209.857 169.298 209.306C169.33 208.754 168.909 208.28 168.358 208.246L168.243 210.243ZM165.462 208.372L165.973 207.515L165.973 207.515L165.462 208.372ZM137.485 191.585L136.972 192.442L136.973 192.442L137.485 191.585ZM118.741 175.754L119.523 175.133L119.523 175.133L118.741 175.754ZM104.153 130.621L105.151 130.677L105.151 130.676L104.153 130.621ZM106.89 77.1644L107.888 77.2196L107.888 77.2194L106.89 77.1644ZM117.52 63.9828L117.244 63.0203L117.243 63.0207L117.52 63.9828ZM171.546 48.6791L171.822 49.6416L171.829 49.6395L171.546 48.6791ZM181.402 49.2305L181.026 50.1559L181.029 50.1569L181.402 49.2305ZM233.529 70.4371L233.155 71.3634L233.157 71.364L233.529 70.4371ZM242.749 84.7063L241.751 84.6501L241.751 84.6512L242.749 84.7063ZM240.01 138.203L239.011 138.147L239.011 138.148L240.01 138.203ZM220.918 181.436L221.631 182.139L221.631 182.139L220.918 181.436ZM200.671 195.095L200.251 194.186L200.25 194.187L200.671 195.095ZM171.205 208.686L170.783 207.777L170.779 207.779L171.205 208.686ZM168.35 208.245C167.798 208.216 167.329 208.639 167.302 209.191C167.274 209.742 167.699 210.213 168.251 210.243L168.35 208.245ZM168.358 208.246C167.518 208.194 166.697 207.949 165.973 207.515L164.95 209.229C165.963 209.837 167.098 210.172 168.243 210.243L168.358 208.246ZM165.973 207.515L137.996 190.727L136.973 192.442L164.95 209.229L165.973 207.515ZM137.997 190.728C130.139 186.008 124.111 180.903 119.523 175.133L117.96 176.375C122.728 182.371 128.954 187.625 136.972 192.442L137.997 190.728ZM119.523 175.133C109.434 162.457 104.326 146.671 105.151 130.677L103.154 130.566C102.304 147.054 107.57 163.32 117.96 176.375L119.523 175.133ZM105.151 130.676L107.888 77.2196L105.891 77.1093L103.154 130.566L105.151 130.676ZM107.888 77.2194C108.181 71.4877 112.158 66.5517 117.798 64.9449L117.243 63.0207C110.806 64.8544 106.228 70.5018 105.891 77.1095L107.888 77.2194ZM117.796 64.9453L171.822 49.6416L171.27 47.7166L117.244 63.0203L117.796 64.9453ZM171.829 49.6395C174.818 48.7684 178.094 48.9534 181.026 50.1558L181.778 48.3052C178.434 46.934 174.694 46.7187 171.263 47.7187L171.829 49.6395ZM181.029 50.1569L233.155 71.3634L233.902 69.5107L181.776 48.3042L181.029 50.1569ZM233.157 71.364C238.605 73.5713 242.05 78.9263 241.751 84.6501L243.747 84.7626C244.093 78.1638 240.124 72.0313 233.901 69.5102L233.157 71.364ZM241.751 84.6512L239.011 138.147L241.008 138.258L243.748 84.7615L241.751 84.6512ZM239.011 138.148C238.196 154.119 231.516 169.241 220.204 180.733L221.631 182.139C233.282 170.304 240.167 154.722 241.008 138.258L239.011 138.148ZM220.204 180.733C215.037 185.979 208.519 190.381 200.251 194.186L201.092 196.004C209.53 192.121 216.262 187.592 221.631 182.139L220.204 180.733ZM200.25 194.187L170.783 207.777L171.626 209.595L201.093 196.004L200.25 194.187ZM170.779 207.779C170.017 208.135 169.183 208.29 168.35 208.245L168.251 210.243C169.402 210.305 170.563 210.091 171.63 209.593L170.779 207.779Z",
    fill: "url(#paint1_linear_502_7502)",
    mask: "url(#path-2-outside-1_502_7502)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_502_7502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.123 116.282H182.061V112.187C182.061 106.535 177.441 101.948 171.748 101.948C166.056 101.948 161.436 106.535 161.436 112.187V116.282H159.373C157.104 116.282 155.248 118.125 155.248 120.377V140.853C155.248 143.106 157.104 144.948 159.373 144.948H184.123C186.392 144.948 188.248 143.106 188.248 140.853V120.377C188.248 118.125 186.392 116.282 184.123 116.282ZM171.748 134.71C169.479 134.71 167.623 132.867 167.623 130.615C167.623 128.363 169.479 126.52 171.748 126.52C174.017 126.52 175.873 128.363 175.873 130.615C175.873 132.867 174.017 134.71 171.748 134.71ZM178.142 116.282H165.354V112.187C165.354 108.685 168.221 105.839 171.748 105.839C175.275 105.839 178.142 108.685 178.142 112.187V116.282Z",
    fill: "white",
    fillOpacity: 0.72,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_502_7502",
    x: 0.123779,
    y: 0.705994,
    width: 217.389,
    height: 217.513,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_502_7502"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_502_7502",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_502_7502",
    x: 79.0653,
    y: 23.0974,
    width: 188.703,
    height: 211.156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_502_7502"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_502_7502",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_502_7502",
    x: 133.248,
    y: 83.9484,
    width: 77,
    height: 87,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_502_7502"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_502_7502",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.3625 0 0 0 0 0.334406 0 0 0 0 0.334406 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_502_7502"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_502_7502",
    x1: 111.071,
    y1: 38.2338,
    x2: 125.47,
    y2: 153.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A689C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36A2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_502_7502",
    x1: 129.394,
    y1: 64.0503,
    x2: 228.005,
    y2: 180.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagePasswordIcon);
export default __webpack_public_path__ + "static/media/ManagePasswordIcon.3e21851d9b49d26488ea98941350b9de.svg";
export { ForwardRef as ReactComponent };